import { EnumContainerOrderAction } from '@Model';

/** The kinds of action a line of the container card can carry, each with its own colour. */
export type ContainerActionKind = 'place' | 'collect' | 'swap' | 'empty';

/** The word the mask names each kind of action by. */
export const ACTION_NOUN: Record<ContainerActionKind, string> = {
    place: 'Stellung',
    collect: 'Abholung',
    swap: 'Tausch',
    empty: 'Leerung',
};

/** The kind of a stored row's action, or `swap` for an exchange. */
// @ai-generated 2026-10-15T12:08:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function actionKindOf(action: EnumContainerOrderAction | 'swap'): ContainerActionKind {
    switch (action) {
        case 'swap':
            return 'swap';
        case EnumContainerOrderAction.Collect:
            return 'collect';
        case EnumContainerOrderAction.Empty:
            return 'empty';
        default:
            return 'place';
    }
}
